<template>
  <div class="car-model-info" v-loading="loading">
    <div class="info-list">
      <div class="info-item space-between">
        <span class="info-title">工商信息</span>
        <el-button v-if="!isDefaultEntity" @click="handleEdit"
          >修改工商信息</el-button
        >
      </div>
      <div class="info-item">
        <span class="label">企业主体全称：</span>
        <span class="value">{{ formattedData.corporationName }}</span>
      </div>
      <div class="info-item">
        <span class="label">统一社会信用代码：</span>
        <span class="value">{{ formattedData.licenceNo }}</span>
      </div>
      <div class="info-item">
        <span class="label">经营状态：</span>
        <span class="value">{{
          formattedData.businessStatusDesc || '--'
        }}</span>
      </div>
      <div class="info-item">
        <span class="label">成立日期：</span>
        <span class="value">{{ formattedData.establishDate || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">登记机关：</span>
        <span class="value">{{
          formattedData.registrationAuthority || '--'
        }}</span>
      </div>
      <div class="info-item">
        <span class="label">经营范围：</span>
        <span class="value">{{ formattedData.businessScope || '--' }}</span>
      </div>
      <div class="info-item">
        <span class="label">注册电话：</span>
        <span class="value">{{
          formattedData.registrationMobile || '--'
        }}</span>
      </div>
      <div class="info-item">
        <span class="label">注册地址：</span>
        <span class="value">{{
          formattedData.registrationAddress || '--'
        }}</span>
      </div>
      <div class="info-item full-width">
        <span class="label">营业执照：</span>
        <div class="image-wrapper">
          <span
            class="a-hover-link"
            v-if="formattedData.businessLicensePic"
            @click="showImages"
            >查看</span
          >
          <span v-else>--</span>
        </div>
      </div>
      <div class="info-item">
        <span class="label">合作平台：</span>
        <span class="value">
          {{ cooperationPlatformDesc || '--' }}
          <span class="add-link" @click="handleOpenCooperationPlatform"
            >添加其他平台</span
          >
        </span>
      </div>
    </div>
    <EditDialog ref="addCarModelRef" @refreshList="refreshTable" />
  </div>
</template>

<script setup>
import EditDialog from '@/pages/organize/enterpriseEntityInfo/addAndEditDialog/index.vue'
import { computed, ref } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  cooperationPlatformDesc: {
    type: String,
    default: '',
  },
})

const emits = defineEmits(['refresh', 'openCooperationPlatformDialog'])

const addCarModelRef = ref(null)

const refreshTable = () => {
  emits('refresh')
}
// 修改信息
const handleEdit = () => {
  addCarModelRef.value.openDrawer('edit', props.data.id)
}

const formattedData = computed(() => {
  const { data } = props
  return {
    ...data,
    establishDate: data.establishDate ? data.establishDate.split(' ')[0] : '',
  }
})

// 是否是默认主体（defaultType 为 0 时不允许编辑）
const isDefaultEntity = computed(() => {
  return props.data && props.data.defaultType === 0
})

const showImages = () => {
  const { businessLicensePic } = formattedData.value
  if (!businessLicensePic) return
  window.open(businessLicensePic, '_blank')
}

// 打开合作平台弹窗
const handleOpenCooperationPlatform = () => {
  emits('openCooperationPlatformDialog')
}
</script>

<style lang="scss" scoped>
.car-model-info {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 10px;
  align-self: stretch;
  background: #f7f8fa;
  border-radius: 5px;

  .info-list {
    display: flex;
    flex-direction: column;
    // gap: 10px;

    .info-item {
      display: flex;
      flex-direction: row;
      padding: 0px 0px 16px 0px;
      gap: 16px;
      align-self: stretch;

      &.full-width {
        width: 100%;
      }

      &.space-between {
        justify-content: space-between;
      }

      .info-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #1d2129;
      }

      .label {
        width: auto;
        color: #606266;
        margin-right: 4px;
        flex-shrink: 0;
        text-align: right;
      }

      .value {
        color: #303133;
        flex: 1;
        overflow: hidden;
        word-break: break-all;

        .add-link {
          color: #366cff;
          margin-left: 8px;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .image-wrapper {
        width: 160px;
        border-radius: 4px;
        overflow: hidden;
      }
    }
  }
}
</style>
